export const API_PATHS = {
  auth: {
    login: '/v1/auth/login',
    refresh: '/v1/auth/refresh',
    logout: '/v1/auth/logout',
    forgotPassword: '/v1/auth/password-reset-request',
    changePassword: '/v1/auth/change-password',
    // Changing your OWN password, which verifies the current one — the reset link's
    // change-password above does not, because it has already proved the address instead.
    // Answers with a fresh session: every other one is revoked.
    updatePassword: '/v1/auth/password',
    autoLogin: '/v1/auth/autologin',
    autoLoginLink: '/v1/auth/autologin/link',
    ssoLogin: '/v1/auth/sso-login',
  },
  subscription: {
    setToken: '/v1/subscription-management/set-token',
    info: '/v2/subscription-management/subscription-info',
    cancel: (id: string) =>
      `/v2/subscription-management/subscription/${id}/cancel`,
    // Non-Visa email-confirmed cancel flow: request the confirmation email…
    cancellationEmail: (id: string) =>
      `/v2/subscription-management/subscription/${id}/cancellation-email`,
    // …and the PUBLIC endpoint the emailed link posts its token to.
    confirmCancellation: '/v2/subscription-management/cancellation/confirm',
    change: (id: string) =>
      `/v2/subscription-management/subscription/${id}/change`,
    restore: (id: string) =>
      `/v2/subscription-management/subscription/${id}/restore`,
    restoreWithPlan: (id: string) =>
      `/v2/subscription-management/subscription/${id}/restore-with-plan`,
    feedbackSubmitImprovement: (id: string) =>
      `/v2/subscription-management/subscription/${id}/feedback/submit-improvement`,
    billingHistory: (id: string) =>
      `/v2/subscription-management/subscription/${id}/billing-history`,
  },
  // GrowthBook feature-flag / experiment assignments for the current user.
  config: '/v1/config',
  // The avatar. POST is multipart and carries coded rejections, so it has its own transport —
  // see features/settings/lib/avatar-service.ts. DELETE is an ordinary authed call.
  userAvatar: '/v1/user/avatar',
  graphql: '/graphql',
} as const
